export const menuItems = [
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        id: 3,
        label: 'menuitems.devices.text',
        icon: 'ri-server-line',
        subItems: [
            {
                id: 300,
                label: 'menuitems.devices.lists',
                link: '/device/list',
                permission: 'device.view'
            },
            {
                id: 309,
                label: 'menuitems.devices.group',
                link: '/device/group',
                permission: 'device.view'
            },
            {
                id: 308,
                label: 'device.button.stockbind',
                link: '/device/stockbind',
                permission: 'device.edit'
            }
        ]
    },
    {
        id: 301,
        label: 'menuitems.devices.orders',
        icon: 'ri-list-ordered',
        link: '/device/orders',
        permission: 'order.view'
    },
    {
        id: 9,
        label: 'menuitems.goods.text',
        icon: 'ri-shopping-bag-2-line',
        link: '/goods/list',
        permission: 'goods.view'
    },
    {
        id: 10,
        label: 'menuitems.admin.text',
        icon: 'ri-admin-line',
        link: '/admin/list',
        permission: 'admin.view'
    },
    {
        id: 11,
        label: 'menuitems.user.text',
        icon: 'ri-file-user-line',
        link: '/user/list',
        permission: 'user.view'
    },
    {
        id: 13,
        label: 'menuitems.wechat.text',
        icon: 'ri-wechat-line',
        subItems:[
            {
                id: 1300,
                label: 'menuitems.wechat.wechatmp.text',
                link: '/wechat/mp',
                permission: 'wechat.view'
            },
            {
                id: 1301,
                label: "menuitems.wechat.micoapp.text",
                link: '/wechat/micoapp',
                permission: 'wechat.view'
            }
        ]
    },
    {
        id:14,
        label: 'menuitems.marketing.text',
        icon: 'ri-coupon-line',
        subItems: [
            {
                id: 1401,
                label: 'menuitems.marketing.wristband.text',
                link: '/marketing/wristband',
                permission: 'marketing.view'
            },
            {
                id: 1402,
                label: 'menuitems.marketing.billing.text',
                link: '/marketing/billing',
                permission: 'marketing.view'
            },
            {
                id: 1403,
                label: 'menuitems.marketing.qrcode_drink.text',
                link: '/marketing/qrcode-drink-label',
                permission: 'marketing.view'
            }
        ]
    },
    {
        id: 8,
        label: 'menuitems.setting.text',
        icon: 'ri-settings-line',
        subItems: [
            {
                id: 800,
                label: 'menuitems.setting.account',
                link: '/setting/account'
            },
            {
                id: 801,
                label: 'menuitems.setting.safty',
                link: '/setting/safty'
            },
            {
                id: 802,
                label: 'menuitems.setting.commonly',
                link: '/setting/commonly'
            },
            {
                id: 803,
                label: 'menuitems.setting.system',
                link: '/setting/system',
                permission: 'system.view'
            },
            {
                id: 804,
                label: 'menuitems.setting.admins.text',
                link: '/setting/admins',
                permission: 'admin.view'
            },
            {
                id: 805,
                label: 'menuitems.setting.permission',
                link: '/setting/permission',
                permission: 'permission.view'
            }
        ]
    },
    {
        id:15,
        label: "menuitems.clouds.text",
        icon: 'ri-cloud-line',
        subItems: [
            {
                id: 1500,
                label: 'menuitems.clouds.nfcreader.text',
                link: '/clouds/nfcreader',
                permission: 'device.view'
            },
            {
                id: 1501,
                label: 'menuitems.clouds.printer.text',
                link: '/clouds/printer',
                permission: 'device.view'
            },
            {
                id: 1505,
                label: 'menuitems.clouds.printer.template.text',
                link: '/clouds/printer/template',
                permission: 'device.view'
            },
            {
                id: 1502,
                label: 'menuitems.clouds.notify.text',
                link: '/clouds/notify',
                permission: 'system.edit'
            },
            {
                id: 1503,
                label: 'menuitems.clouds.payment.text',
                link: '/clouds/payment',
                permission: 'system.edit'
            },
            {
                id: 1504,
                label: 'menuitems.clouds.cloudbind.text',
                link: '/clouds/cloud-bind',
                permission: 'system.edit'
            }
        ]
    },
    {
        id: 16,
        label: 'menuitems.cashier.text',
        icon: 'ri-store-2-line',
        link: '/cashier',
        permission: 'marketing.view'
    },
    {
        id: 12,
        label: 'menuitems.setting.initialization',
        icon: 'ri-file-info-line',
        link: '/initialization',
        permission: 'system.edit'
    },
    {
        id: 62,
        label: 'menuitems.setting.statistics',
        icon: 'ri-stack-line',
        link: '/statistics',
        permission: 'system.view'
    },
    {
        id: 64,
        label: 'menuitems.setting.export',
        icon: 'ri-file-excel-2-line',
        link: '/export',
        permission: 'system.view'
    },
    {
        id: 63,
        label: 'menuitems.console.text',
        icon: 'ri-terminal-box-line',
        link: '/console',
        permission: 'admin.view'
    },
    {
        id: 99,
        label: 'about.text',
        icon: 'ri-flag-line',
        link: '/about'
    },
    {
        id: 18,
        isLayout: true
    }
]
